import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { MentionedBy } from '@bepure/tarkin';

interface Image {
    link: string;
    alt: string;
}

interface Props {
    text?: string;
    imageList?: Image[];
}

const MentionedBySection = (props: Props) => {
    return (
        <MentionedBy
            text={props.text ? props.text : ''}
            imageList={props.imageList ? props.imageList : []}
        />
    );
};

export default function render() {
    const elements = document.getElementsByClassName('mentioned-by-section');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const imageJSON = element.getAttribute('data-imageList');
        const imageList = JSON.parse(imageJSON || '');
        return ReactDOM.render(
            <MentionedBySection
                text={element.getAttribute('data-text') || ''}
                imageList={imageList}
            />,
            element,
        );
    });
}
